import React, { Component, Fragment } from "react";
import loadable from "@loadable/component";

// import Header from "./../common/header";
// import Footer from "./../common/footer";

import { scrollToTop } from "./../../helpers/screen";

const Header = loadable(() => import("./../common/header"));
const Footer = loadable(() => import("./../common/footer"));

export default class Default extends Component {
    componentDidMount() {
        scrollToTop();
    }

    render() {
        const {
            id,
            dark = true,
            homepage = false,
            children = "",
            showLogin = false,
            notify = [],
            onLoginSuccess = false,
            onLoginClose = false,
            type = false,
            extensions = false,
        } = this.props;
        let { className = [] } = this.props;

        if (!(className instanceof Array)) {
            className = [className];
        }
        className.unshift("layout");
        if (type) {
            className.push(type);
        }

        return (
            <Fragment>
                <div id={id} className={className.join(" ")}>
                    <div id="page-top"></div>
                    <div className="content-container">
                        <Header
                            darkmode={dark}
                            homepage={homepage}
                            showLogin={showLogin}
                            onLoginSuccess={onLoginSuccess}
                            onLoginClose={onLoginClose}
                            notify={notify}
                            type={type}
                            extensions={extensions}
                        />
                        {children}
                        <Footer />
                    </div>
                </div>
            </Fragment>
        );
    }
}
